class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartWishlistButton extends HTMLElement {
  constructor() {
    super();

    this.customerId = window.GLOBAL.customerId;
    this.productId = this.dataset.productId;
    this.variantId = this.dataset.variantId;
    this.handle = this.dataset.handle;
    this.qty = this.dataset.cartQuantity;

    this.wishlist = window.GLOBAL?.wishlist;
    this.wishlistItem = null;

    window.GLOBAL.wishlist &&
      this.handleWishlistLoaded({ detail: window.GLOBAL.wishlist });
    window.document.addEventListener(
      "wishlistLoaded",
      this.handleWishlistLoaded.bind(this)
    );

    this.addEventListener("click", this.addWishList.bind(this));
  }

  async addWishList(event) {
    event.preventDefault();

    if (!this.customerId) return;

    // console.log("wishlistItemId", this.wishlistItem);

    let wishlistItemId = this.wishlistItem?.WishListItemID;

    if (!wishlistItemId) {
      await addToWishlist({
        customerId: this.customerId,
        productId: this.productId,
        handle: this.handle,
        variantId: this.variantId,
        qty: this.qty,
      });
      await this.refreshWishlist();
    }
  }

  handleWishlistLoaded({ detail }) {
    this.wishlist = detail.data;
    this.wishlistItem = this.findWishlistItem();
  }

  findWishlistItem() {
    if (!this.wishlist) {
      return;
    }
    return this.wishlist.find(({ ProductID }) => ProductID === this.productId);
  }

  async refreshWishlist() {
    window.GLOBAL.wishlist = await getWishlist();
    const event = new window.CustomEvent("wishlistLoaded", {
      detail: window.GLOBAL.wishlist,
    });
    window.document.dispatchEvent(event);
  }
}

customElements.define("cart-wishlist-button", CartWishlistButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    // const debouncedOnChange = debounce((event) => {
    //   this.onChange(event);
    // }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", (event) => {
      if(event.target.classList.contains("js-header-checkbox")){
        this.handleHeaderCheckbox(event);
      }else if(event.target.classList.contains("js-checkbox")){
        this.handleCheckbox(event)
      }else{
        debounce((event) => {
          this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER)(event)
      }
    });


    // this.addEventListener("change", debouncedOnChange.bind(this));

    this.initCheckboxes();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  getCheckboxes(){
    return {
      headerCheckbox : this.querySelector("#cart-item-th-checkbox > input[type='checkbox']"),
      checkboxes: this.querySelectorAll(".cart-item__checkbox>input[type='checkbox']")
    }
  }

  initCheckboxes(){
    this.selectedCartItems = new Map();

    const {headerCheckbox, checkboxes} = this.getCheckboxes();
    // if (checkboxes && checkboxes.length) {
    //   checkboxes.forEach((ele) => {
    //     ele.checked = false;
    //     ele.addEventListener("change", this.handleCheckbox.bind(this));
    //   });
    // }

    if (headerCheckbox) {
      headerCheckbox.checked = false;

      headerCheckbox.addEventListener(
        "change",
        this.handleHeaderCheckbox.bind(this)
      );

      const event = new Event("change", { bubbles: true });
      headerCheckbox.dispatchEvent(event);
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    // debugger;
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  } 

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.renderCartUpdate(state, line, name, variantId);
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  renderCartUpdate(state, line, name, variantId) {
    const parsedState = JSON.parse(state);
    const quantityElement =
      document.getElementById(`Quantity-${line}`) ||
      document.getElementById(`Drawer-quantity-${line}`);
    const items = document.querySelectorAll(".cart-item");
    if (parsedState.errors) {
      quantityElement.value = quantityElement.getAttribute("value");
      this.updateLiveRegions(line, parsedState.errors);
      return;
    }

    this.classList.toggle("is-empty", parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector("cart-drawer");
    const cartFooter = document.getElementById("main-cart-footer");

    if (cartFooter)
      cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
    if (cartDrawerWrapper)
      cartDrawerWrapper.classList.toggle(
        "is-empty",
        parsedState.item_count === 0
      );

    this.getSectionsToRender().forEach((section) => {
      if (section.id === "cart-icon-bubble") {
        document.querySelectorAll("a#cart-icon-bubble").forEach((element) => {
          let html = new DOMParser()
            .parseFromString(parsedState.sections[section.section], "text/html")
            .querySelector(section.selector);
          let cart_bubble = html.querySelector(".js-cart-bubble");
          element.querySelector(".js-cart-bubble").innerHTML =
            cart_bubble.innerHTML;
        });
      } else {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);

        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        let hasOnlyGiftItems = false;
        if(parsedState.items.length === 1){
          let lastItem = parsedState.items[0]
          let giftItem = elementToReplace.querySelector(`.giftList[data-id='${lastItem.variant_id}']`)
          hasOnlyGiftItems = !!giftItem
        }
        if(hasOnlyGiftItems){
          this.clearCartItems()
        }
      }
    });
    const updatedValue = parsedState.items[line - 1]
      ? parsedState.items[line - 1].quantity
      : undefined;
    let message = "";
    if (
      items.length === parsedState.items.length &&
      updatedValue !== parseInt(quantityElement.value)
    ) {
      if (typeof updatedValue === "undefined") {
        message = window.cartStrings.error;
      } else {
        message = window.cartStrings.quantityError.replace(
          "[quantity]",
          updatedValue
        );
      }
    }
    this.updateLiveRegions(line, message);

    const lineItem =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper
        ? trapFocus(
            cartDrawerWrapper,
            lineItem.querySelector(`[name="${name}"]`)
          )
        : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(
        cartDrawerWrapper.querySelector(".drawer__inner-empty"),
        cartDrawerWrapper.querySelector("a")
      );
    } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "cart-items",
      cartData: parsedState,
      variantId: variantId,
    });

    this.initCheckboxes();
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }

  handleHeaderCheckbox(event) {
    event.preventDefault();
    event.stopPropagation();
    let checked = event.target.checked;
    const { checkboxes } = this.getCheckboxes();
    // console.log(this.table.querySelectorAll('.td-checkbox > input[type=checkbox]'))
    checkboxes.forEach((element) => {
      element.checked = checked;
      const event = new Event("change", { bubbles: true });
      element.dispatchEvent(event);
    });
  }

  handleCheckbox(event) {
    event.preventDefault();
    event.stopPropagation();

    const checked = event.target.checked;
    const parentNode = event.target.closest("tr");
    // console.log(parentNode.dataset.index);
    let index = parentNode.dataset.index;
    let id = parentNode.dataset.itemId;
    let quantity = parentNode.dataset.quantity;
    let data = { id, quantity, index };

    // ele.checked = checked;
    if (checked) {
      this.selectedCartItems.set(index, data);
      event.target.setAttribute("checked", true);
    } else {
      this.selectedCartItems.delete(index);
      event.target.removeAttribute("checked");
    }
  }

  getSelectedRows() {
    return this.selectedCartItems.size > 0
      ? Array.from(this.selectedCartItems, ([_, v]) => v)
      : [];
  }

  unCheckAll(checkboxes) {
    checkboxes.forEach((e) => {
      e.checked = false;
    });
  }

  deleteMultipleCart() {
    let cartItems = this.getSelectedRows();
    // console.log(
    //   "deletemultiplecart",
    //   this.selectedCartItems,
    //   this.getSelectedRows()
    // );
    if (!cartItems?.length) return;

    var formData = new FormData();
    cartItems.forEach((e) => {
      formData.append(`updates[${e.id}]`, "0");
    });
    formData.append(
      "sections",
      this.getSectionsToRender()
        .map((section) => section.section)
        .join(",")
    );
    formData.append("sections_url", window.location.pathname);

    cartItems.forEach((i) => {
      this.enableLoading(i.index);
    });

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        // console.log("deletemultiplecart completed", state);
        for (let i = 0; i < cartItems.length; i++) {
          const cartItem = cartItems[i];
          this.renderCartUpdate(state, cartItem.index, null, cartItem.id);
        }
      })
      .catch((error) => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        cartItems.forEach((i) => {
          this.disableLoading(i.index);
        });
      });
  }

  async createCheckout() {
    let items = this.getSelectedRows();
    
    if (!items?.length) return;

    const SHOP = window.GLOBAL.shop;
    const STOREFRONT_URL = `https://${SHOP}/api/2025-01/graphql.json`
    const ACCESS_TOKEN = window.GLOBAL.storefrontAccessToken;

    const query = `mutation cartCreate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          id
          checkoutUrl
        }
        userErrors {
          field
          message
        }
      }
    }`;

    const variables = {
      input: {
        lines: items.map(({ id, quantity }) => ({
          merchandiseId: `gid://shopify/ProductVariant/${id}`,
          quantity: parseInt(quantity, 10),
        })),
      },
    };

    const response = await fetch(STOREFRONT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN,
      },
      body: JSON.stringify({ query, variables }),
    });

    const responseData = await response.json();
    //console.log(responseData);

    if (responseData?.errors?.length) {
      throw new Error(JSON.stringify(responseData.errors));
    }
    const data = responseData.data;

    // console.log("createCheckout", data);

    const { cartCreate } = data;
    const { cart } = cartCreate;
    const { id, checkoutUrl } = cart;

    if(checkoutUrl){
      const url = new URL(checkoutUrl);
      const redirect = window.location.origin + checkoutUrl.replace(url.origin, '');
      window.location = redirect;
    }
  }

  clearCartItems(){
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`/cart/clear.js`,  { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.renderCartUpdate(state, "1");
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}